import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import {
  Articoli,
  Articoli_FilterTableModel,
  Articoli_TableModel,
  Articolo_PrintQrModel,
  Articolo_ViewModel,
  Environment,
  ModelBool,
  ModelNum,
  ModelNumStr,
  ModelStr,
} from '../../models/-index';
import { CrudGenericsService } from '../common/crud-generics';

@Injectable()
export class ArticoliService extends CrudGenericsService<Articoli, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Articoli`);
    this.base = `${env.apiUrl}/api/Articoli/`;
  }

  //
  Get4Select_ByIds(model: ModelNum[], vis_codice: boolean = false): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_ByIds?vis_codice=${vis_codice}`;
    return this.http.post<ModelNumStr[]>(u, model).pipe(take(1));
  }
  Get4Select_Filtered(filter: string): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_Filtered?filter=${filter}`;
    return this.http.get<ModelNumStr[]>(u).pipe(take(1));
  }
  Get4Select_ByMagLocazione(id: number): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_ByMagLocazione?id=${id}`;
    return this.http.get<ModelNumStr[]>(u);
  }

  // cambio qr per id
  GetIdArticolo_ByQRCode(qr: string): Observable<ModelNum> {
    const u = `${this.base}GetIdArticolo_ByQRCode?qr=${qr}`;
    return this.http.get<ModelNum>(u);
  }
  // singola proprietà
  Articolo_GestioneLottoSeriali(id: number): Observable<ModelBool> {
    const u = `${this.base}Articolo_GestioneLottoSeriali?id=${id}`;
    return this.http.get<ModelBool>(u);
  }
  // check unique
  Unique_CodArticolo(string: string): Observable<ModelBool> {
    // model in post, le stringhe potrebbero avere caratteri strani...
    const model: ModelStr = { Value: string };
    const u = `${this.base}Unique_CodArticolo`;
    return this.http.post<ModelBool>(u, model).pipe(take(1));
  }

  // view
  GetArticolo_ViewModel(id: number, qr: string = ''): Observable<Articolo_ViewModel> {
    const u = `${this.base}GetArticolo_ViewModel?id=${id}&qr=${qr}`;
    return this.http.get<Articolo_ViewModel>(u);
  }
  // table
  GetArticoli_TableModel(filter: Articoli_FilterTableModel): Observable<Articoli_TableModel[]> {
    const u = `${this.base}GetArticoli_TableModel`;
    return this.http.post<Articoli_TableModel[]>(u, filter);
  }
  //print qr
  GetArticolo_PrintQrModel(id: number): Observable<Articolo_PrintQrModel> {
    const u = `${this.base}GetArticolo_PrintQrModel?id=${id}`;
    return this.http.get<Articolo_PrintQrModel>(u);
  }
  // aggiorna solo SchedadiSicurezza
  FastUpdateSdS(item: Articoli) {
    const u = `${this.base}FastUpdateSdS`;
    return this.http.put(u, item);
  }
}
